import { apiConfig } from '../config';
import { postFetch } from '../fetch';

interface PatchNotificationsRequestData {
    ids: Array<number>;
    isViewed: boolean;
}

export function patchNotifications(requestData: PatchNotificationsRequestData): Promise<void> {
    const { apiPatchNotifications } = apiConfig.getStaticUrls();

    return postFetch(apiPatchNotifications, {
        ids: requestData.ids,
        is_viewed: requestData.isViewed,
    });
}
